import * as S from './styles'
import { useDayToDayCulture } from './useDayToDayCulture'
import { Text } from '@/components'
import { Dropdown } from '@/components/dropdown'
import { useIsVisibleElement } from '@/hooks'
import { DayToDayCulture } from '@/service/api/culturePage/types'

export type DayToDayCultureContainerProps = {
  data: DayToDayCulture
}

export const DayToDayCultureContainer: React.FC<
  DayToDayCultureContainerProps
> = ({ data }) => {
  const { fontSizes, isSmallDesktop } = useDayToDayCulture()

  const { element, elementVisible } = useIsVisibleElement()

  return (
    <S.DayToDayCultureContainer>
      <Text align="left" size={fontSizes.title} color="black" className="title">
        {data.title}
      </Text>
      <Text size={fontSizes.description} color="black">
        {data.description}
      </Text>
      {data.topics.length > 0 &&
        data.topics.map((topic, index) => (
          <S.TopicContainer
            key={topic.title}
            ref={index + 1 === data.topics.length - 1 ? element : null}
          >
            <Text
              size={fontSizes.topicTitle}
              color="black"
              className="topic-title"
            >
              {topic.title}
              <S.Bar color={topic.color} elementIsVisible={elementVisible} />
            </Text>
            <S.SubtopicContainer>
              {topic.subtopics.map((subtopic) =>
                isSmallDesktop ? (
                  <Dropdown
                    key={subtopic.title}
                    label={subtopic.title}
                    content={subtopic.description}
                  />
                ) : (
                  <div key={subtopic.title} className="subtopic">
                    <Text
                      size={fontSizes.subtopicTitle}
                      color="black"
                      className="subtopic-title"
                    >
                      {subtopic.title}
                    </Text>
                    <Text
                      size={fontSizes.subtopicDescription}
                      color="black"
                      className="subtopic-description"
                    >
                      {subtopic.description}
                    </Text>
                  </div>
                ),
              )}
            </S.SubtopicContainer>
          </S.TopicContainer>
        ))}
    </S.DayToDayCultureContainer>
  )
}
